import * as React from "react";
import style from "./index.module.scss";
import testImg1 from "./img/test1.png";
import testImg2 from "./img/test2.png";
import testImg3 from "./img/test3.png";
import testImg4 from "./img/test4.png";
import testImg5 from "./img/test5.png";
import ExperimentItem from "./components/ExperimentItem";
import { Button, Input, Spin } from "antd";
import CustomEmpty from "components/CustomEmpty";
import { getCloudDeskExperimentList } from "API/navExperiment";
import { useEffect, useState } from "react";
import useRequestFn from "Utils/useRequestFn";
import { errorMessage } from "Utils/useRequest";
import { ResultMessage } from "components/ResultMessage";

function getImgUrl(index: number) {
    const ImgArr = [testImg1, testImg2, testImg3, testImg4, testImg5];
    const num = index % ImgArr.length;
    return ImgArr[num];
}

export default function ExperimentList() {
    const [search, setSearch] = useState("");
    const [getData, { loading, data }] = useRequestFn(
        getCloudDeskExperimentList
    );

    useEffect(() => {
        getData();
    }, []);

    async function handleSearch() {
        try {
            await getData(search);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            <div className={style.tools}>
                <div className={style.leftTools}>
                    实验项目（{data?.length || "0"}）
                </div>
                <div>
                    <Input
                        placeholder="输入项目名称"
                        className={style.input}
                        maxLength={50}
                        onChange={e => setSearch(e.target.value)}
                        onPressEnter={handleSearch}
                    />
                    <Button
                        type="primary"
                        className={style.searchBtn}
                        icon="search"
                        onClick={handleSearch}>
                        查询
                    </Button>
                </div>
            </div>

            <Spin spinning={loading}>
                {data?.length !== 0 && (
                    <div className={style.main}>
                        {data?.map((item, index) => (
                            <ExperimentItem
                                data={item}
                                className={style.item}
                                imgUrl={getImgUrl(index)}
                                key={item.id}
                            />
                        ))}
                    </div>
                )}

                {data?.length === 0 && (
                    <CustomEmpty
                        style={{ padding: "220px 0" }}
                        description="暂无实验项目"
                    />
                )}
            </Spin>
        </div>
    );
}
